import React from 'react'
import { RouteObject } from 'react-router-dom'
import { MaintenanceLayout } from '@components/layout/MaintenanceLayout'
import { lazyPage } from '@app/utils/routeUtils'

export const maintenanceRoutes: RouteObject[] = [
  {
    path: 'maintenance',
    element: <MaintenanceLayout />,
    children: [
      {
        index: true,
        element: lazyPage('MkPageMaintenance', 'maintenance'),
      },
    ],
  },
]
